export const COLORS = {
  primary: '#0F7C55',
  red: 'rgb(203, 0, 0)'
};

export const modalStyles = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '96%',
  overflow: 'scroll',
  transform: 'translate(-50%, -50%)',
  width: { xs: '95%', md: '70%' },
  bgcolor: '#FFF',
  borderRadius: 2,
  boxShadow: 24,
  p: 2
};
